import ServiceBase from "base/baseService"

export default class TipoFluxoService extends ServiceBase {

    title = "Tipo de fluxo"
    pluralTitle = "Tipos de fluxo"
    url = '/cadastro/fiscal/tipofluxo'
    frontUrl = '/cadastro/fiscal/tipofluxo'
    frontUrlList = '/cadastro/fiscal/tipofluxolist'
    primaryKey = 'codigo_tiflu'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Se usar Switch (Se não permite null?)

        // Se usar checkbox (Se permite null?)

        // Numéricos com FK notNullable

        // Strings notNullable

        data.codigo_tiflu = data?.codigo_tiflu || ''
        data.descricao_tiflu = data?.descricao_tiflu || ''

        // Numéricos sem FK

        // Dependentes

        // Datas

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
